import AdminSettingsPage from './AdminSettingsPage';
import DefaultOfferSettingsPortal from '../components/DefaultOfferSettingsPortal';
import '../default-offer-settings.css';

export default function AdminSettingsPageWithDefaultOffer(){
  return <>
    <AdminSettingsPage />
    <DefaultOfferSettingsPortal />
  </>;
}
